import { createFileRoute, useParams } from "@tanstack/react-router";
import { requireFeature } from "@/lib/feature-gate";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import { ApprovalDetailPage } from "@/components/supervisor/ApprovalDetailPage";

export const Route = createFileRoute("/supervisor/_layout/approvals_/$id")({
  beforeLoad: () => requireFeature("leave"),
  component: SupervisorApprovalDetail,
});

function SupervisorApprovalDetail() {
  const { id } = useParams({ from: "/supervisor/_layout/approvals_/$id" });
  return (
    <SidebarInset>
      <DashboardHeader current={"Request Detail"}
      />
      <div className="flex flex-col gap-4 p-6 pt-0">
        <ApprovalDetailPage approvalId={id} />
      </div>
    </SidebarInset>
  );
}
